
import { Types } from 'app/actions/company-admin/page-match-inquiries';
import utils from 'app/reducers/utils';

const initialState = {
  matchInquiryIds: null,
  pagination: null,
  loadPending: false,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.SEARCH}_PENDING`]: (state, _action) => {
    return {...state,
      matchInquiryIds: null,
      pagination: null,
      loadPending: true,
    };
  },
  [`${Types.SEARCH}_RESOLVED`]: (state, {result: {matchInquiries, pagination}}) => {
    return {...state,
      matchInquiryIds: matchInquiries.map(ed => ed.id),
      pagination,
      loadPending: false,
    };
  },
  [`${Types.SEARCH}_REJECTED`]: (state, {error}) => {
    return {...state,
      matchInquiryIds: null,
      pagination: null,
      loadPending: false,
    };
  },

});

export default reducer;
